import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import image1 from './images/coffee/doppio3.png'
import image2 from './images/coffee/americano.png'
import image3 from './images/coffee/cappucino2.png'
import image4 from './images/coffee/latte.png'
import image5 from './images/coffee/flat-white.png'
import image6 from './images/coffee/irish-cream-latte.png'
import image7 from './images/coffee/caramel-latte.png'
import image8 from './images/coffee/hazelnut-latte.png'
import image9 from './images/coffee/vanilla-latte.png'
import image10 from './images/coffee/cinnamon-latte.png'
import image11 from './images/coffee/mocha.png'
import image12 from './images/coffee/nutella-nutty-latte.png'
import image13 from './images/coffee/lotus-biscoff-latte.png'
import './menu.css'
import NavigationBar from './nav';
import NewNav from './canvas';
import Aos from 'aos';
import "aos/dist/aos.css";
import { useEffect } from 'react';

function Coffee() {
  const products = [
    { id: 1, name: "Doppio", image: image1 },
    { id: 2, name: "Americano", image: image2 },
    { id: 3, name: "Cappucino", image: image3 },
    { id: 4, name: "Latte", image: image4 },
    { id: 5, name: "Flat White", image: image5 },
    { id: 6, name: "Irish Cream Latte", image: image6 },
    { id: 7, name: "Caramel Latte", image: image7 },
    { id: 8, name: "Hazelnut Latte", image: image8 },
    { id: 9, name: "Vanilla Latte", image: image9 },
    { id: 10, name: "Cinnamon Latte", image: image10 },
    { id: 11, name: "Mocha", image: image11 },
    { id: 12, name: "Nutella Nutty Latte", image: image12},
    { id: 13, name: "Lotus Biscoff Latte", image: image13 },
  ]
   useEffect(()=>{
      Aos.init({duration:"1000"})
    })
  return (
    <>
    <Container fluid>
              <Row>
              <NavigationBar/>
              <NewNav/>
                <Col id='coffeeTop'>  
                <Row>
                  <Col id='rockHeading'>
                  <p data-aos="zoom-in">Coffee</p>
                  </Col>
                </Row>
                </Col>
              </Row>
            </Container>
      <Container>
        <Row>
          <Col style={{justifyContent: "center",gap: "20px"}}>
            <Row>
              {products.map((p)=>(
              <Col xs={3} md={3} key={products.id} style={{ marginTop: "20px",textAlign:"center",gap:"20px"}}>
                <Card data-aos="zoom-in" md={12} style={{border:"none"}}>
                  <Card.Img id='CardImg'  
                  src={p.image} />
                  <Card.Body style={{padding:"5px 0px"}}>
                    <Card.Title id='cardName'>{p.name}</Card.Title>
                  </Card.Body>
                </Card>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Coffee